export const capitalize = (s: string) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export const capitalizeFullName = (s: string) => {
    if (typeof s !== 'string') return ''
    return s.split(' ').map(word => capitalize(word)).join(' ')
}